import React, { useEffect } from 'react'
import { Table } from 'reactstrap';
import { ITypeForTopTen } from '../../types';
import DotsSpinner from '../Loader/DotsSpinner/DotsSpinner';
import { useStatsMoreDetails } from './hooks/useStatsMoreDetails'
type IProp = {
  type: ITypeForTopTen
  district: string;
  block: string;
  week_no: number;
}
const StatsMoreDetails = ({ district, block, type, week_no }: IProp) => {
  const {
    isLoading,
    data,
    getClickData,
  } = useStatsMoreDetails()

  let extraTableLabels = {
    Total_app_usage: "Total PAL Usage (in mins)",
    District: "District",
    Total_assessments: "Total PAL Homework",
    Total_Usage: "Total PAL Usage by Students (in mins)",
    Total_Remedial: "Total PAL Remedial Tests Attempted by Students",
    Total_Assessments: "Total PAL Homework Attempted by Students"
  };

  useEffect(() => {
    getClickData(district, block, type, week_no)
  }, []);
  
  return (<>
    {isLoading ? (
      <div style={{ height: "60vh" }}>
        <DotsSpinner />
      </div>
    ) : (<>
      {data &&

        <Table striped hover>
          <tr>
            {Object.keys(data[0]).map((key) => (
              <th key={key}><h3>{extraTableLabels[key] ? extraTableLabels[key] : key}</h3></th>
            ))}
          </tr>
          <tbody>
            {data.map((item) => (
              <tr key={item.district}>
                {Object.keys(item).map((key) => (
                  <td className='text-sm font-weight-bold ' key={key}>{item[key] ? item[key] : 0}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>}
    </>)
    }
  </>)
}

export default StatsMoreDetails
